import { PagePayload } from '@core/interface/core';
import {
  CorrectiveActionPayload,
  ExcelPayload,
  VehicleCheckCommonResponse,
  VehicleCheckError,
  VehicleCheckExcelResponse,
  VehicleCheckPayload,
  VehicleCheckResponse,
  VerifiedPayload,
} from '@core/interface/fleet/daily-vehicle-check';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const VehicleCheckActions = createActionGroup({
  source: 'VehicleCheck',
  events: {
    'Load Inspected Vehicles': props<VehicleCheckPayload>(),
    'Load Inspected Vehicles Success': props<VehicleCheckResponse>(),
    'Load Inspected Vehicles Failure': props<VehicleCheckError>(),
    'Mark as Verified': props<VerifiedPayload>(),
    'Mark as Verified Success': props<VehicleCheckCommonResponse>(),
    'Mark as Verified Failure': props<VehicleCheckError>(),
    'Update Corrective Action': props<{ data: CorrectiveActionPayload[] }>(),
    'Update Corrective Action Success': props<{ data: any }>(),
    'Update Corrective Action Failure': props<VehicleCheckError>(),
    'Export PDF': props<ExcelPayload>(),
    'Export PDF Success': props<VehicleCheckExcelResponse>(),
    'Export PDF Failure': props<VehicleCheckError>(),
    'Reset Inspected Vehicles': emptyProps(),
    'Reset Verified Status': emptyProps(),
    'Reset Corrective Action Status': emptyProps(),
  },
});
